<template>


    <!-- Main container -->
    <div class="login-header">
        <nav class="level">

            <!-- Left side -->
            <div class="level-left">
                <div class="level-item">
                    <a :href="homepage">
                      <img src="../../images/logo.svg" class="login-logo">
                    </a>
                </div>
            </div>

            <!-- Right side -->
            <div class="level-right is-hidden-touch">
                <slot></slot>
            </div>
        </nav>
    </div>


</template>

<script>
import {config} from "@/config/config";

export default {
  name: "LoginHeader.vue",
  data() {
    return {
      homepage:config('HOMEPAGE')
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
